import { useMemo } from "react";

import { Emptyable, formatBodyForRecipient, Locales } from "@simplyk/common";

import { trpc } from "@/common/helpers/trpc";
import { useLocaleContext } from "@/common/contexts/LocaleContext";

interface UseFormattedEmailBodyInput {
  body: string;
  emailContentId?: Emptyable<string>;
  recipientEmails: string[];
}

const defaultRecipient = (locale: Locales) => ({
  firstName: "John",
  lastName: "Smith",
  email: "john.smith@gmail.com",
  id: "",
  hasUnsubscribed: false,
  contactId: "",
  locale,
});

export const useFormattedEmailBody = ({
  body,
  emailContentId,
  recipientEmails,
}: UseFormattedEmailBodyInput): string => {
  const { locale } = useLocaleContext();
  const { data: emailDeliveryVariables } = trpc.getPreviewEmailDeliveryVariables.useQuery(
    {
      emailContentId: emailContentId as string,
      recipientEmails,
      occurrenceId: undefined,
    },
    { enabled: Boolean(emailContentId) }
  );

  const formattedBody = useMemo(
    () =>
      formatBodyForRecipient({
        frontendUrl: process.env.NEXT_PUBLIC_FRONTEND_URL as string,
        recipient: emailDeliveryVariables?.recipients?.[0] || defaultRecipient(locale),
        body,
        variables: emailDeliveryVariables?.variables,
        locale,
      }),
    [body, emailDeliveryVariables?.recipients, emailDeliveryVariables?.variables, locale]
  );

  return `
  <style>
    a {
      color: #0000EE;
      text-decoration: underline;
    }
  </style>
  ${formattedBody}
`;
};
